import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/components/auth/Auth'
import Login from '@/components/auth/Login'
import Dashboard from '@/components/dashboard/Dashboard'
import MenuCentral from '@/components/dashboard/MenuCentral'

// usuario
import PasswordUser from '@/components/user/PasswordUser'
import CapitanPort from '@/components/user/CapitanPort'
import AdminUser from '@/components/user/AdminUser'

// despacho de naves
import Question from '@/components/cotizacion/Question'
import SearchBoat from '@/components/cotizacion/searchBoat'
import BoatRegister from '@/components/cotizacion/boatRegister'
import NotRegister from '@/components/cotizacion/boatNotRegister'
import NotRegisterSancion from '@/components/cotizacion/boatNotRegisterSancion'
import ReportIne from '@/components/cotizacion/reportIne'

// registro de matricula
import Enrollment from '@/components/matriculacion/Matriculacion'
import ApprovEnrollment from '@/components/matriculacion/ApprovMatriculacion'
import ApprovEnrollmentAdmin from '@/components/matriculacion/AdminMatriculacion'
import UploadPhoto from '@/components/matriculacion/UploadPhoto'
import MatriculacionDirecta from '@/components/matriculacion/MatriculacionDirecta' 
import EnrollmentOrderPrint from '@/components/matriculacion/OrderPrintEnrollment'
import PrintEnrollment from '@/components/matriculacion/PrintEnrollment'
import UpdloadFirmDirector from '@/components/matriculacion/UploadFirmDirector'
import ResumeShips from '@/components/matriculacion/ResumeShips'
import PasavanteOptions from '@/components/matriculacion/PasavanteOptions'
import MatriculacionPasavant from '@/components/matriculacion/MatriculacionPasavant'

// registro de cargas
import RegisterCharge from '@/components/config/registerCharge'

// verificacion y validez de la matricula con fotografia
import SearchBoatValidate from '@/components/verify/SearchBoatValidate'

// descargo de operaciones
import Discharge from '@/components/finanzas/Descargo'
import sendDischarge from '@/components/finanzas/SendDischarge'

// Renovaciones
import Renew from '@/components/renew/Renew'
import SendRenew from '@/components/renew/SendRenew'

// Reportes
import ReportPendingOp from '@/components/reports/ReportsPendingOperations'

// Rectificaciones
import SearchBoatRe from '@/components/rectification/SearchBoatRe'

// Finanzas
import BudgetConf from '@/components/finanzas/BudgetConf';
import BudgetCeiling from '@/components/finanzas/BudgetCeiling';
import BudgetExecute from '@/components/finanzas/BudgetExecute';
import BudgetReport from '@/components/finanzas/BudgetReport';
import ReimpresionDoc from '@/components/finanzas/ReimpresionDoc';
import ReprintDischarge from '@/components/finanzas/ReprintDischarge'

// orden de operacion
import Ordop from '@/components/ordop/ordop';
import OrdopReport from '@/components/ordop/OrdopReport';
import OrdopResume from '@/components/ordop/OrdopResume';
import OrdopDetailReport from '@/components/ordop/OrdopDetailReport';
import OrdopAnexo from '@/components/ordop/OrdopAnexo'
import MapsOrdopPoint from '@/components/ordop/MapsOrdopPoint'
import OrdopApproveMilla from '@/components/ordop/OrdopApproveMilla'
import OrdopCertificate from '@/components/ordop/OrdopMillasPersonal'

// multas y sanciones por contravenciones a la navegacion
import Penalty from '@/components/penalty/Penalty'

// unidades de superficie capitanias de puerto
import uuss from '@/components/uuss/uuss'
import engine from '@/components/uuss/engine'
import ReportCaptain from '@/components/uuss/reportCaptains'

// servicios de capitanias de puerto
import servicesCaptain from '@/components/services/services'
import PersonalCaptain from '@/components/user/PersonalCaptain'
import TableCaptainResume from '@/components/captain/TableCaptainResume'
import AddUnitCaptain from '@/components/captain/AddUnitCaptain'

// componente chart
import OrdopCharts from '@/components/charts/OrdopCharts'

// componente de mapas
// import LoadMap from '@/components/maps/LoadMap'
import NewLocationCaptain from '@/components/maps/NewLocationCaptain'
import MapsCaptainView from '@/components/maps/MapsCaptainView'
import MapsCaptainViewJuris from '@/components/maps/MapsCaptainViewJuris'
import NewLocationJurisdiccion from '@/components/maps/NewLocationJurisdiccion'
import MapsOrdopVigent from '@/components/maps/MapsCaptainViewOrdopVigent'
import MapsLocationOrdop from '@/components/maps/NewLocationOrdopInit'

// componente de subir fotografias de las capitanias
import UploadPhotoCaptain from '@/components/captain/UploadPhotoCaptain';

// componente de administracion y configuracion del sistema
import AdminUfv from '@/components/ufv/adminUfv';

// componente que embebe el reporte
import Report from '@/components/report/report'

// reporte de los ingresos por distintos conceptos
import ReportEnter from '@/components/finanzas/ReportEnter'

// denuncias en las capitanias
import Complaints from '@/components/complaints/Complaints'

// niveles de rios
import River from '@/components/river/riverLake'
import ReadRiver from '@/components/river/readRiver'
import ReportRiver from '@/components/river/reportRiver'

// propietario
import UpdateOwner from '@/components/matriculacion/UpdateOwner'
import ChangeOwnerShip from '@/components/matriculacion/ChangeOwnerShip'

// Baja de una embarcacion
import DownShip from '@/components/matriculacion/DownShip'

// reimpresion de documentos
import ReimpresionShip from '@/components/finanzas/ReimpresionShip'

// marina mercante
import AssignRegister from '@/components/uumm/AssignRegister'
import RegisterPort from '@/components/uumm/RegisterPort'
import RegisterEmpresa from '@/components/uumm/RegisterEmpresaPuerto'
import ReportListEmpresa from '@/components/uumm/ReportListEmpresas'
import ReportVencidos from '@/components/uumm/ReporteVencidos'

// Tareas de Fax Mensajes y Otros
import NewTaskCaptain from '@/components/captain/NewTaskCaptain'

Vue.use(Router)

function rutaResguardada(to, from, next){
  if(Vue.auth.loggedIn()){
    next('/dashboard')
  }else{
    next();
  }
}

const routes=[
  {path:'/', redirect:'/auth/login', name:'inicio'},
  {path:'/report/:tpdf', component:Report},
  {
    path:'/auth',
    component:Auth,
    redirect:'/auth/login',
    children:[
      {path:'login', component: Login, name: 'login', beforeEnter:rutaResguardada}
    ]
  },
  {
    path:'/dashboard',
    component:Dashboard,
    name:'dashboard',
    redirect:'dashboard/central',
    meta: { requiresAuth : true },
    children:[
      {path:'central', component:MenuCentral},
      {path:'question', component:Question},
      {path:'search', component: SearchBoat },
      {path:'boat-register', component: BoatRegister },
      {path:'not-register', component: NotRegister },
      {path:'not-register-sancion',component: NotRegisterSancion},
      {path:'enrollment', component:Enrollment},
      {path:'reporte-ine', component:ReportIne},
      {path:'approved-enrollment', component:ApprovEnrollment},
      {path:'admin-approved', component:ApprovEnrollmentAdmin},
      {path:'discharge', component:Discharge},
      {path:'discharge-document', component:sendDischarge},
      {path:'renew-ship', component:Renew},
      {path:'send-renew', component:SendRenew},
      {path:'rectification/:tipo', component:SearchBoatRe, props:true},
      {path:'report-pending', component:ReportPendingOp},
      {path:'upload-ship', component:UploadPhoto},
      {path:'verify-enrollment', component:SearchBoatValidate},
      {path:'password', component:PasswordUser},
      {path:'enrollment-direct', component:MatriculacionDirecta},
      {path:'register-capitan', component:CapitanPort},
      {path:'conf-budget', component:BudgetConf},
      {path:'conf-ceiling', component:BudgetCeiling},
      {path:'exec-budget', component:BudgetExecute},
      {path:'report-budget', component:BudgetReport},
      {path:'order-print', component:EnrollmentOrderPrint},
      {path:'print-enrollment', component:PrintEnrollment},
      {path:'ord-op', component:Ordop},
      {path:'ordop-location', component:MapsLocationOrdop},
      {path:'ord-op-r', component:OrdopReport},
      {path:'ord-res', component:OrdopResume},
      {path:'penalty', component:Penalty},
      {path:'users', component:AdminUser},
      {path:'uuss', component:uuss},
      {path:'engine', component:engine},
      {path:'ordop-charts', component:OrdopCharts},
      {path:'captain-table', component:ReportCaptain},
      {path:'captain-location', component:NewLocationCaptain},
      {path:'location-captains', component:MapsCaptainView},
      {path:'juris-captains', component:MapsCaptainViewJuris},
      {path:'services-captain', component:servicesCaptain},
      {path:'persons-captain', component:PersonalCaptain},
      {path:'jurisdiccion-captain', component:NewLocationJurisdiccion},
      {path:'ordopmapvigent', component:MapsOrdopVigent},
      {path:'photo-captain', component:UploadPhotoCaptain},
      {path:'ufv-config', component:AdminUfv},
      {path:'report-ingress', component:ReportEnter},
      {path:'denounces-police', component:Complaints},
      {path:'ordop-details', component:OrdopDetailReport},
      {path:'firm-director', component:UpdloadFirmDirector},
      {path:'ordopnexo', component:OrdopAnexo},
      {path:'ordopapprovemilla', component:OrdopApproveMilla},
      {path:'ordopositive', component:MapsOrdopPoint},
      {path:'resume-ship', component:ResumeShips},
      {path:'reprint-doc', component:ReimpresionDoc},
      {path:'register-charge', component:RegisterCharge},
      {path:'reprint-discharge', component:ReprintDischarge},
      {path:'river-lake', component:River},
      {path:'river-read', component:ReadRiver},
      {path:'report-river', component:ReportRiver},
      {path:'update-owner', component:UpdateOwner},
      {path:'change-owner', component:ChangeOwnerShip},
      {path:'reprint-doc-ship', component:ReimpresionShip},
      {path:'pasavante-options', component:PasavanteOptions},
      {path:'pasavant-enroll', component:MatriculacionPasavant},
      {path:'down-ship', component:DownShip},
      {path:'uumm-sign', component:AssignRegister},
      {path:'ordop-certificate', component:OrdopCertificate},
      {path:'table-resume-ccpp', component:TableCaptainResume},
      {path:'add-unit-captain', component:AddUnitCaptain},
      {path:'register-port', component:RegisterPort},
      {path:'register-empresa-vias', component:RegisterEmpresa},
      {path:'report-list-empresa', component:ReportListEmpresa},
      {path:'report-list-vencidos-uumm', component:ReportVencidos},
      {path:'task-captain', component:NewTaskCaptain}
    ]
  }
]

export default new Router({
  // mode: 'history',
  mode:'hash',
  base: __dirname,
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js